import type {
    SignalAdNetworksFilterProps,
} from "app/pages/sales-intelligence/sub-modules/signals/components/filters/SignalAdNetworksFilter/SignalAdNetworksFilter";
import SignalAdNetworksFilter from "app/pages/sales-intelligence/sub-modules/signals/components/filters/SignalAdNetworksFilter/SignalAdNetworksFilter";
import { buildAdNetworksTrackingValue } from "app/pages/sales-intelligence/sub-modules/signals/services/tracking/signals-filters/helpers";
import trackingService from "app/pages/sales-intelligence/sub-modules/signals/services/tracking/trackingService";

type Props = SignalAdNetworksFilterProps & {
    signalAlias: string;
};

const SignalAdNetworksFilterTracked = (props: Props) => {
    const handleTrackedChange = (updatedValues: ReadonlyArray<number>) => {
        const trackingValue = buildAdNetworksTrackingValue(updatedValues, props.options);

        trackingService.filters.trackAdNetworkFilterChange(trackingValue, props.signalAlias);
        props.onValueChange(updatedValues);
    };

    return (
        <SignalAdNetworksFilter
            {...props}
            onValueChange={handleTrackedChange}
        />
    );
};

export default SignalAdNetworksFilterTracked;
